export const AVIATOR_GAME_ID = 5656;
